import { Box, Grid, Stack, Typography } from "@mui/material";
import React from "react";
import {
  blackShade19,
  border25,
  displaySwitchGreenColor,
  displaySwitchRedColor,
  greyColor6,
  lightGreen14,
  lightRedColor02,
  whiteColor,
} from "../../../configs/styles/muiThemes";

function CategoryPreview({
  productName,
  categoryData,
  selectedVariant,
  hideWebCategory,
  hideProductName,
}) {
  return (
    <Box sx={styles.card}>
      <Grid container spacing={2}>
        {!hideProductName && (
          <Grid item md={3} xs={12}>
            <Box>
              <Typography
                component="h6"
                fontSize={{ xs: 12, md: 12 }}
                color={greyColor6}
                fontWeight={400}
                lineHeight="20px"
                mb={{ md: 1, xs: 0.5 }}
              >
                Product Name
              </Typography>
              <Typography
                component="h6"
                fontSize={{ xs: 12, md: 13 }}
                color={blackShade19}
                fontWeight={500}
                lineHeight="20px"
              >
                {productName}
              </Typography>
            </Box>
          </Grid>
        )}
        <Grid item md={4} xs={12}>
          <Stack gap={1}>
            <Typography sx={styles.title}>ONDC</Typography>
            <InfoCard
              label="Enabled"
              value={categoryData?.ondcEnabled === "yes" ? "Yes" : "No"}
              chip
            />
            <InfoCard
              label="Category"
              value={categoryData?.selectedOndcCat?.name}
            />
            <InfoCard
              label="Sub Category"
              value={categoryData?.selectedOndcSubCat?.productSubCategory1}
            />
          </Stack>
        </Grid>
        {!hideWebCategory && (
          <Grid item md={5} xs={12}>
            <Stack gap={1}>
              <Typography sx={styles.title}>Webstore Categories</Typography>
              <InfoCard
                label="Business Category"
                value={categoryData?.selectedBusinessCat?.name}
              />
              <InfoCard
                label="Product Category"
                value={categoryData?.selectedProductCat?.value}
              />
              <InfoCard
                label="Product Sub-Category"
                value={categoryData?.selectedProductSubCat?.value}
              />
            </Stack>
          </Grid>
        )}
        <Grid item md={5} xs={12}>
          <Stack gap={1}>
            <Typography sx={styles.title}>Variants</Typography>
            <Grid container columnSpacing={2}>
              <Grid item md={8} xs={5}></Grid>
              <Grid item md={4} xs={5}>
                <Typography
                  component="h6"
                  fontSize={{ xs: 12, md: 12 }}
                  color={greyColor6}
                  fontWeight={400}
                  lineHeight="20px"
                >
                  Tags
                </Typography>
              </Grid>
            </Grid>

            <VariantInfoCard
              label="Variant 1"
              value={selectedVariant?.variant1?.value?.displayName}
              tag={`${selectedVariant?.variant1?.tag ? "Yes" : "No"}`}
            />
            {selectedVariant?.variant2?.value && (
              <VariantInfoCard
                label="Variant 2"
                value={selectedVariant?.variant2?.value?.displayName}
                tag={`${selectedVariant?.variant2?.tag ? "Yes" : "No"}`}
              />
            )}
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
}

export default CategoryPreview;

const InfoCard = ({ label, value, chip }) => {
  return (
    <Grid container spacing={2}>
      <Grid item md={4} xs={5}>
        <Typography
          component="h6"
          fontSize={{ xs: 12, md: 12 }}
          color={greyColor6}
          fontWeight={400}
          lineHeight="20px"
        >
          {label}
        </Typography>
      </Grid>
      <Grid item md={8} xs={7}>
        {chip ? (
          <Typography
            component="h6"
            sx={{
              bgcolor:
                value?.toLowerCase() == "yes" ? lightGreen14 : lightRedColor02,
              p: "2px 15px",
              borderRadius: "50px",
              cursor: "pointer",
              display: "inline-block",
            }}
            fontSize={{ xs: 12, md: 12 }}
            color={
              value?.toLowerCase() == "yes"
                ? displaySwitchGreenColor
                : displaySwitchRedColor
            }
            fontWeight={500}
            lineHeight="20px"
          >
            {value}
          </Typography>
        ) : (
          <Typography
            component="h6"
            fontSize={{ xs: 12, md: 13 }}
            color={blackShade19}
            fontWeight={500}
            lineHeight="20px"
            textTransform={"capitalize"}
          >
            {value}
          </Typography>
        )}
      </Grid>
    </Grid>
  );
};

const VariantInfoCard = ({ label, value, tag }) => {
  return (
    <Grid container spacing={2}>
      <Grid item md={4} xs={5}>
        <Typography
          component="h6"
          fontSize={{ xs: 12, md: 12 }}
          color={greyColor6}
          fontWeight={400}
          lineHeight="20px"
        >
          {label}
        </Typography>
      </Grid>
      <Grid item md={4} xs={7}>
        <Typography
          component="h6"
          fontSize={{ xs: 12, md: 13 }}
          color={blackShade19}
          fontWeight={500}
          lineHeight="20px"
          textTransform={"capitalize"}
        >
          {value}
        </Typography>
      </Grid>
      <Grid item md={4} xs={7}>
        <Typography
          component="h6"
          fontSize={{ xs: 12, md: 13 }}
          color={blackShade19}
          fontWeight={500}
          lineHeight="20px"
          textTransform={"capitalize"}
        >
          {tag}
        </Typography>
      </Grid>
    </Grid>
  );
};

const styles = {
  card: {
    backgroundColor: whiteColor,
    borderRadius: "13px",
    border: border25,
    boxShadow: "0 3px 4px rgb(229 233 240 / 22%)",
    p: "10px 15px",
    mb: 2,
  },
  title: {
    fontSize: 14,
    fontWeight: 600,
    lineHeight: "20px",
    color: blackShade19,
    mt: { xs: -1, md: 0 },
  },
};
